import KeyboardArrowRightOutlined from "@mui/icons-material/KeyboardArrowRightOutlined";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import { useTranslation } from "react-i18next";

/** Bouton « Voir / Masquer l'historique (N) » qui déplie les prix passés d'un canal. */
export const HistoryToggleButton = ({
    isOpen,
    pastCount,
    onToggle,
}: {
    isOpen: boolean;
    pastCount: number;
    onToggle: () => void;
}) => {
    const [t] = useTranslation();

    return (
        <button
            type="button"
            onClick={onToggle}
            className="inline-flex items-center gap-0.5 text-[11px] text-gray-500 font-medium bg-transparent border-0 cursor-pointer hover:text-gray-700 transition-colors whitespace-nowrap"
        >
            {isOpen ? (
                <KeyboardArrowDownOutlinedIcon sx={{ width: 14, height: 14 }} />
            ) : (
                <KeyboardArrowRightOutlined sx={{ width: 14, height: 14 }} />
            )}
            {isOpen ? t("PriceHistory.HideHistory") : t("PriceHistory.ShowHistory", { count: pastCount })}
        </button>
    );
};
